<!--
 * @Author: cgh
 * @Date: 2022-07-28
 * @LastEditors: zxf
 * @LastEditTime: 2023-08-23 16:27:13
 * @Description: 查看计划详情
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        查看计划详情
      </h2>
      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          v-if="fd.jhzt === 'DGZ' && fd.tsbz !== 'Y'"
          v-permission-element="'wbxm_sqxg'"
          btn-text="申请修改"
          :auth-type="true"
          type="warning"
          plain
          @click="handleDialog('sqxg',{wbjhId:fd.id, id: filterParams.xmId})"
        />
        <k-button
          btn-text="维保结论"
          :auth-type="false"
          type="primary"
          icon="iconfont icon-jielun"
          @click="handleDialog('wbjl', {jhid: fd.id})"
        />
        <k-button
          v-if="fd.jhzt === 'DSC'"
          v-permission-element="'wbxm_scbg'"
          btn-text="生成报告"
          :auth-type="true"
          type="primary"
          plain
          icon="iconfont icon-baogao"
          @click="generateReport()"
        />
        <k-button
          v-if="fd.jhzt === 'DSC'"
          v-permission-element="'wbxm_scbg_ls'"
          btn-text="生成临时报告"
          :auth-type="true"
          type="primary"
          plain
          icon="iconfont icon-baogao"
          @click="generateTempReport()"
        />
        <k-button
          v-if="lsbgFileId"
          btn-text="查看临时报告"
          :auth-type="false"
          type="primary"
          plain
          icon="kestrel-icon ki-file-pdf"
          :disabled="fd.previewPdf"
          @click="(e)=>$utils.previewPdf(e,lsbgFileId,fd)"
        >
          <i
            v-show="fd.previewPdf"
            class="el-icon-loading"
          />
        </k-button>
        <!-- <k-button
          btn-text="导出"
:auth-type="false"
          v-if="bgxx.bgscztDm === 'Y'"
          type="primary"
          plain
          icon="iconfont icon-dayin"
          @click="(e)=>$utils.previewPdf(e,bgxx.bgUrl)"
        >
          打印报告
        </k-button>
        <k-button
          btn-text="导出"
:auth-type="false"
          v-if="bgxx.bgscztDm === 'Y'"
          type="primary"
          plain
          icon="iconfont icon-dayin"
          @click="(e)=>$utils.previewPdf(e,bgxx.gspbgUrl)"
        >
          打印报告(含公式牌)
        </k-button> -->
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="handleClose()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <hm-page-card
        class="c-card-detail"
      >
        <div class="o-tips u-mg-b-10">
          <div class="o-tips__title">
            说明:
          </div>
          <ul class="o-tips__">
            <li class="o-tips__item">
              1、所有检查项都必须填写完整才可生成报告；
            </li>
            <li class="o-tips__item">
              2、生成报告后如需修改请用主账号在维保计划管理开启重新修改功能。
            </li>
          </ul>
        </div>
        <el-form
          ref="fd"
          class="c-form"
          :model="fd"
          :inline="true"
          label-position="right"
          label-width="120px"
          label-suffix="："
        >
          <!-- 基本信息 -->
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              维保计划
            </el-col>

            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <span
                  class="c-form__read"
                >
                  {{ fd.xmmc || '-' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="计划维保时间"
                prop="jhnf"
              >
                <span
                  class="c-form__read"
                >
                  {{ fd.jhsjQ | date("yyyy-MM-dd") }}  ~ {{ fd.jhsjZ | date("yyyy-MM-dd") }}（{{ fd.jhlxMc || '-' }}）
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="计划名称"
                prop="jhmc"
              >
                <span
                  class="c-form__read"
                >
                  {{ fd.jhmc || '-' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目负责人"
                prop="xmfzrMc"
              >
                <span
                  class="c-form__read"
                >
                  {{ fd.xmfzrMc || '-' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="技术负责人"
                prop="jsfzrMc"
              >
                <span
                  class="c-form__read"
                >
                  {{ fd.jsfzrMc || '-' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="维保人员"
                prop="wbryMc"
              >
                <span
                  v-for="(item,index) in fd.wbryDmList"
                  :key="`czy-${index}`"
                  class="c-form__read"
                >
                  {{ item.userName || '-' }} {{ fd.wbryDmList.length === index + 1 ?' ': '、' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="维保内容"
                prop="wbnrJhList"
              >
                <span
                  v-for="(item,index) in fd.wbnrJhList"
                  :key="`维保内容${index}`"
                  class="c-form__read"
                >
                  {{ index+1 }}、{{ item.wbnrMc || '-' }} {{ fd.wbnrJhList.length === index + 1 ?' ': '；' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="任务描述"
                prop="rwms"
              >
                <span
                  class="c-form__read"
                >
                  {{ fd.rwms || '-' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="维保报告"
                prop="bgbh"
              >
                <span
                  v-if="fd.bgbh"
                  class="u-mg-r-6 c-form__read u-text-primary"
                >
                  {{ fd.bgbh }}
                </span>
                <k-button
                  v-if="fd.bgbh"
                  btn-text="查看维保报告"
                  :auth-type="false"
                  type="primary"
                  plain
                  icon="kestrel-icon ki-file-pdf"
                  :disabled="fd.previewPdf"
                  @click="(e)=>$utils.previewPdf(e,fd.bgUrl,fd)"
                >
                  <i
                    v-show="fd.previewPdf"
                    class="el-icon-loading"
                  />
                </k-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 维保系统 Start -->
        <template>
          <div
            class="o-part-title"
          >
            <span
              class="u-mg-r-10"
            >
              维保系统
            </span>
          </div>
          <el-table
            ref="listTable"
            class="c-page__table o-header-text-center"
            stripe
            border
            highlight-current-row
            tooltip-effect="dark"
            :data="wbxtTjPage.rows"
            :class="{ 'o-table-empty-center': wbxtTjPage.rows.length <= 0 }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="40"
              align="center"
            />
            <el-table-column
              prop="wbnrMc"
              label="系统名称"
              min-width="180"
            >
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  @click="handleDialog('jcxtb', {xtid: scope.row.wbnrId, jhid: fd.id})"
                >
                  {{ scope.row.wbnrMc }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="zxsl"
              label="检测项数量"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.zxsl || '-' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="wcxsl"
              label="已完成数量"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.wcxsl }}
              </template>
            </el-table-column>
            <el-table-column
              prop="wwcxsl"
              label="未完成数量"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.wwcxsl }}
              </template>
            </el-table-column>
          </el-table>
        </template>

        <!-- 维保系统 End -->
        <template>
          <div
            class="o-part-title"
          >
            <span
              class="u-mg-r-10"
            >
              巡查测试登记
            </span>
            ({{ fd.jhsjQ | date("yyyy-MM-dd") }}  至 {{ fd.jhsjZ | date("yyyy-MM-dd") }})
            <k-button
              btn-text="导出原始数据"
              :auth-type="false"
              type="primary"
              icon="kestrel-icon ki-export"
              class="u-mg-l-10"
              plain
              :disabled="page.rows.length<1"
              @click="handleExport()"
            />
          </div>

          <k-table
            ref="xccsTable"
            v-loading="xccsLoading"
            :is-full-page="false"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @size-change="handleSizeChange"
          >
            <template
              #sbzt="scope"
            >
              <div
                :class="{
                  'u-text-danger': scope.row.sbzt === 'N',
                  'u-text-success': scope.row.sbzt === 'Y'
                }"
              >
                {{ scope.row.sbzt === 'Y' ? '正常' :'故障' }}
              </div>
            </template>
          </k-table>
        </template>
        <!-- 巡查测试 End -->
      </hm-page-card>
    </div>
    <!-- 页面主内容：详情 End -->

    <view-dialog
      v-if="showDialogName==='jcxtb'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="init()"
    />

    <!-- 维保结论 -->
    <wbjl-dialog
      v-if="showDialogName==='wbjl'"
      :type="(fd.jhzt==='WKS' || fd.jhzt==='ZXZ' || fd.jhzt==='DSC') ? 'edit' : 'view'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="init()"
    />

    <!-- 申请修改 -->
    <sqxg-dialog
      v-if="showDialogName === 'sqxg'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>

<script>
import { wbjhService } from '../wbjh.service.js';
import { wbjhxqService } from './wbjhxq.service';
import { xccsdjManageService } from '@/features/xfwbgl/xccsdj/xccsdj.service.js';
import WbjlDialog from './wbjlDialog.vue';
import sqxgDialog from '@/features/xfwbgl/bggl/SqxgDialog.vue';

export default {
  name: 'ViewWbjh',
  components: {
    viewDialog: () => import('./viewDialog'),
    WbjlDialog,
    sqxgDialog
  },
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading状态
      /* 表单参数 Start */

      xccsLoading: false, // 巡查测试登记页面loading状态

      bgxx: {}, // 报告信息

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */
      fd: {
        id: null,
        khbm: null, // 项目名称
        jhnf: null, // 计划年份
        jhmc: null, // 计划名称
        jhlxMc: null, // 计划类型
        jhsjQ: null, // 计划开始时间
        jhsjZ: null, // 计划结束时间
        wbryMc: null, // 维保人员
        xmfzrMc: null, // 项目负责人
        jsfzrMc: null, // 技术负责人
        wbnrMc: null, // 维保内容
        rmms: null // 任务描述
      },
      filterParams: {
        xcsjQ: null,
        xcsjZ: null,
        xmId: null,
        jhlx: null
      },
      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      wbxtTjPage: {
        rows: []
      },
      /* 查询结果 End */
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'wbnrMc', label: '巡检系统', align: 'left', width: '180', type: 'text' },
        { key: 'xfsbMc', label: '巡检设备', align: 'left', width: '180', type: 'text' },
        { key: 'jzwMc', label: '建筑物', align: 'left', minWidth: '140', type: 'text' },
        { key: 'lc', label: '所在楼层', align: 'left', width: '80', type: 'text' },
        { key: 'sbwz', label: '具体位置', align: 'left', minWidth: '100', type: 'text' },
        { key: 'sbzt', slotName: 'sbzt', label: '设备状态', align: 'left', width: '80', type: 'text' },
        { key: 'sbsl', label: '数量', align: 'left', with: '80', type: 'text' },
        { key: 'xclxMc', label: '类型', align: 'left', width: '80', type: 'text' },
        { key: 'xcryMc', label: '操作员', align: 'left', width: '100', type: 'text' },
        { key: 'xcsj', label: '巡检日期', align: 'center', width: '100', type: 'date' },
        { key: 'cjsj', label: '登记日期', align: 'center', width: '100', type: 'date' }

      ],
      /* 表格列配置End */
      /* 表单参数 End */
      lsbgFileId: null // 临时报告文件id
    };
  },

  methods: {
    /**
     * @description: 生成维保正式 报告
     * @return {*}
     */
    generateReport () {
      const _this = this;
      _this.$confirm('是否确认生成维保报告？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        wbjhxqService.generateReport({ wbjhId: this.fd.id, xmId: this.filterParams.xmId })
          .then(rsp => {
            _this.$alert('生成报告成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            this.queryWbjhInfo();
          }).catch(err => {
            console.error('生成报告异常！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 生成维保临时报告
     * @return {*}
     */
    generateTempReport () {
      const _this = this;
      _this.loading = true;
      wbjhxqService.generateTempReport(this.fd.id)
        .then(rsp => {
          _this.lsbgFileId = rsp.data.data;
        })
        .catch(err => {
          console.error('生成临时报告错误！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description 关闭
     * @param {*}
     * @return {*}
     */
    handleClose () {
      this.closeNavTabAndTo();
    },

    /**
     * 获取详情信息
     */
    async init () {
      this.loading = true;
      // 获取维保系统统计信息
      this.getWbxtTj();
      await this.queryWbjhInfo();
      // 获取巡查测试数据信息
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.getXccsdj();
    },
    async queryWbjhInfo () {
      return wbjhService.getInfo(this.fd.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
          this.filterParams.xcsjQ = this.fd.jhsjQ;
          this.filterParams.xcsjZ = this.fd.jhsjZ;
          this.filterParams.jhlx = rsp.data.jhlxDm;
          this.filterParams.xmId = rsp.data.xmId;
        }).catch(err => {
          console.error('查询维保计划详情信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 获取维保系统统计信息
     */
    getWbxtTj () {
      this.loading = true;
      wbjhService.getWbxtTj(this.fd.id)
        .then(rsp => {
          this.wbxtTjPage.rows = rsp.data;
        }).catch(err => {
          console.error('查询维保系统信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 获取巡查测试登记数据（查看计划详情页面）
     */
    getXccsdj (_pageNo = 1) {
      this.xccsLoading = true;
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */
      xccsdjManageService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询巡查测试登记数据错误！', err);
        })
        .finally(() => {
          this.xccsLoading = false;
        });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      xccsdjManageService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
       * @description: 跳转窗口
       * @author: cgh
       */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    }
  },
  created () {
    this.fd.id = this.$route.params.id;
    this.init();
    // this.getWbjhBgxx();
  }
};
</script>
